import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { CageCrudService } from 'src/app/shared/services/cage-crud.service';
import { Cage } from 'src/app/shared/interfaces/cage';
import { Harvest } from '../shared/interfaces/harvest';
import { HarvestCrudService } from '../shared/services/harvest-crud.service';
import { Fridge } from '../shared/interfaces/fridge';
import { FridgeCrudService } from '../shared/services/fridge-crud.service';


@Component({
  selector: 'app-cages',
  templateUrl: './cages.component.html',
  styleUrls: ['./cages.component.scss']
})
export class CagesComponent implements OnInit {

  quantity : number = 0;
  fridgeKey : string = '';

  cages: Cage[];
  cage: Cage;
  selectedCages: Cage[] = [];

  harvests: Partial<Harvest>[];
  harvestNames: string[];
  harvestsMap : Map<string,Harvest>;

  fridges: Partial<Fridge>[];
  fridgesMap : Map<string,Harvest>;


  cageDialog: boolean = false;
  moveDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private cageService : CageCrudService,
    private harvestService : HarvestCrudService,
    private fridgeService : FridgeCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Cages'}
    ];

    this.cages = [];
    this.cage = { } as Cage ;

    this.harvests = [];
    this.harvestNames = [];
    this.harvestsMap = new Map<string,Harvest>();

    this.fridges = [];
    this.fridgesMap = new Map<string,Fridge>();
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.cageService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.cages = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Cage = jsonItem as Cage;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.cages.push(l);
        }
      })
    });

    let h = this.harvestService.getList(); 
    h.snapshotChanges().subscribe(data => {
      this.harvests = [];
      this.harvestNames = [];
      this.harvestsMap.clear();
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Harvest = jsonItem as Harvest;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          //l.code = l.name;
          let ll : Partial<Harvest> = l;
          //delete ll.$key;
         // if (l.isEnabled ) {
            this.harvests.push(ll);
            this.harvestNames.push(l.name);
         // }
          this.harvestsMap.set(ll.$key || 'na' , l);
        }
      });
     // console.log(this.grapeVarieties);
     this.harvests = this.harvests.sort((a, b) => ( (a.position || 0) < (b.position || 1) ) ? -1 : 1);
    });

    let f = this.fridgeService.getList(); 
    f.snapshotChanges().subscribe(data => {
      this.fridges = [];
      this.fridgesMap.clear();
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Harvest = jsonItem as Harvest;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          //l.code = l.name;
          let ll : Partial<Harvest> = l;
          //delete ll.$key;
         // if (l.isEnabled ) {
            this.fridges.push(ll);
         // }
          this.fridgesMap.set(ll.$key || 'na' , l);
        }
      });
     // console.log(this.grapeVarieties);
     this.fridges = this.fridges.sort((a, b) => ( (a.position || 0) < (b.position || 1) ) ? -1 : 1);

     if (this.fridges && this.fridges.length > 0) {
      this.fridgeKey = this.fridges[0].$key || '';
     }

    });

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Notes' },
      { field: 'tags', header: 'Tags' },

      //{ field: 'harvestName', header: 'Harvest' },
      // { field: 'fishAverageWeight', header: 'Weight (avg)' },
      // { field: 'fishNumber', header: 'Fish (nb)' },
      // { field: 'fishMortality', header: 'Mortality (nb / %)' },
      // { field: 'filledAt', header: 'Filled at' },
      // { field: 'emptiedAt', header: 'Emptied at' },

      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
   // this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'tags');
  //  this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.cageService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.cages);
            doc.save('cages.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.cages);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "cages");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedCages);
      // console.log('SAVEC CSV LOCATIONS ', this.cages);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedCages, 'cages', exportCols);
   // this.exportService.exportToCsv(this.cages, 'cages', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.cage = {} as Cage;
    this.submitted = false;
    this.cageDialog = true;
  }

  openMove(cage: Cage) {
    this.cage = cage;
    this.submitted = false;
    this.moveDialog = true;
  }

  deleteSelectedCages() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected cages?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.cages = this.cages.filter(val => !this.selectedCages.includes(val));
            
            this.selectedCages.forEach( cage => this.cageService.delete(cage.$key));
            this.selectedCages = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Cagess Deleted', life: 3000});
        }
    });
  }

  editCage(cage: Cage) {
    this.cage = {...cage};
    this.cageDialog = true;
  }

  deleteCage(cage: Cage) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + cage.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.cages = this.cages.filter(val => val.$key !== cage.$key);
            this.cage = {} as Cage;
            this.cageService.delete(cage.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Cage Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.cageDialog = false;
    this.submitted = false;
  }

  hideMoveDialog() {
    this.moveDialog = false;
    this.submitted = false;
  }

  saveCage() {
    this.submitted = true;

    if ( this.cage.name.trim() ) {
      if (this.cage.$key) {
          this.cages[this.findIndexById(this.cage.$key)] = this.cage;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Cage Updated', life: 3000});
          this.cageService.update(this.cage);
        } else {
          this.cage.position = this.cages.length;
          this.cageService.add(this.cage);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Cage Created', life: 3000});
      this.cages = [...this.cages];
    }

    this.cageDialog = false;
    this.cage = { } as Cage;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.cages.length; i++) {
        if (this.cages[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeCage(cage : Cage) {
    console.log(cage);
    console.log(this.harvests);
    this.cageService.update(cage);
  }

  completePosition(cage : Cage) {
    if ( this.newPosition > -1 ) {
        cage.position = this.newPosition;
        cage = this.checkPositionLimits(cage);
        this.reorderElements(cage);
        //this.updateDB(cage);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.cages);
    // const myClonedArray = [];
    // this.cages.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.cages.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.cages.length - 1 - event.dropIndex;
    const cageToMove = this.cages[startIndex];

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.cages[index] = this.cages[index+1];
        this.cages[index].position = index;
        this.cageService.update(this.cages[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.cages[index] = this.cages[index-1];
        this.cages[index].position = index;
        this.cageService.update(this.cages[index]);
      }
    } 
    this.cages[endIndex] = cageToMove;
    this.cages[endIndex].position = endIndex;
    this.cageService.update(this.cages[endIndex]);
  }

  // onFieldEdit(cage: Spray, fieldName: string): void {
  //   //console.log(this.cages);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + cage[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       cage.position = this.newPosition;
  //       cage = this.checkPositionLimits(cage);
  //       this.reorderElements(cage);
  //       //this.updateDB(cage);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(cage);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.cages.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, cage: Cage) {
    // console.log("event" +event);
    if (cage.position != null && cage.position > -1) {
      this.previousPosition = cage.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(cage: Cage) {
    console.log('check ',cage.position + ' ' + this.cages.length);
    if (!cage.position) {
     // console.log('check 1');
      return this.cage;
    }
    if (cage.position < 0) {
      cage.position = 0;
      // console.log('check 2');
      return cage;
    }
    if (cage.position > this.cages.length) {
      cage.position = this.cages.length - 1;
    //  console.log('check 3', cage.position);
      return cage;
    }
   // console.log('check 4');
    return cage;
  }

  async reorderElements(cage: Cage) {
    this.newPosition = this.newPosition  > this.cages.length ? this.cages.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === cage.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const cageToMove = this.cages[startIndex];
   // console.log('Item to move: ', this.cages[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.cages);
        console.log('Item to +1: ', this.cages[index+1]);

        this.cages[index] = this.cages[index+1];
        this.cages[index].position = index;
        // console.log('Move: ', this.cages[index+1]);
        // console.log('Move pos: ', this.cages[index].position);
        //await this.updateDB(this.cages[index]);
        this.cageService.update(this.cages[index]);
     //   console.log('Update DB: ', this.cages[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.cages[index] = this.cages[index-1];
        this.cages[index].position = index;
        this.cageService.update(this.cages[index]);
      }
    } 
    this.cages[endIndex] = cageToMove;
    this.cages[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.cageService.update(this.cages[endIndex]);
    
    // const myClonedArray = [];
    // this.cages.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.cages = myClonedArray;
   // this.getAllRecords();
  }


  onSelect (event: any, cage: Cage) {
    //this.completeBarrel(barrel);
  }

  onBlur(event: any, cage: Cage) {
    this.completeCage(cage);
  }

  onClose(event: any, cage: Cage) {
    this.completeCage(cage);
  }


  onChangeHarvest(cage: Cage, cageHarvestKey: string, event: any): boolean {

    // console.log('barrel event', event);
    // console.log('be ', event);

    const newKey = event.value;
    const previousKey = cageHarvestKey;
    console.log('new key wanted',  newKey);
    console.log('before key ', previousKey);

    // Si il n'y en avait pas avant et ni maintenant, riemn a faire
    if (!previousKey && !newKey) {
      console.log('save1 ');
      return true;
    }

    // Si le barril est le meme rien a faire
    if (previousKey && newKey && previousKey == newKey) {
      console.log('save2 ');
      return true;
    }


    // Sil il n'y avait pas de barril avant et maintenant oui
    if (!previousKey && newKey) {

      const newHarvest = this.harvestsMap.get(newKey) || {} as Harvest;
      const newHarvestName = newHarvest.name;
        
      cage.harvestKey = newKey;
      cage.harvestName = newHarvestName;
      console.log('save3 ');
      this.cageService.update(cage);
      return true;

    }

    if (previousKey && !newKey) {
      cage.harvestKey = '';
      cage.harvestName = '';
      console.log('save4 ');
      this.cageService.update(cage);
      return true;
    }

    const newRegion = this.harvestsMap.get(newKey) || {} as Harvest;
    const newHarvestName = newRegion.name;
        
    cage.harvestKey = newKey;
    cage.harvestName = newHarvestName;
    this.cageService.update(cage);
    return true;
  }

  displayHarvestName(key : string): string {
    if (this.harvestsMap.has(key)) {
      return this.harvestsMap.get(key)?.name || '';
    }
    return '';
  }

  moveToFridge(cage: Cage) {
    // this.cage = {...cage};
    // this.cageDialog = true;
    this.openMove(cage)
    this.moveDialog = true;
    //this.confirm({} as Event, []);

  }
  
  
  confirm(event: Event, items : any[]) {
    this.confirmationService.confirm({
        target: event.target || {} as EventTarget,
        header: 'Confirmation',
        // message: 'Are you moving the entire product?',
        // icon: 'pi pi-exclamation-triangle',
        accept: () => {
            //confirm action
           
 
        },
        reject: () => {
            //reject action
            
        }
    });
  }

}